import { StaticPageId } from '../data';
import { useAggregatedStaticPagesConfig } from './use-aggregated-static-pages-config';

export const useLinkResolver = (): ((pageId: StaticPageId) => string) => {
  const aggregatedPages = useAggregatedStaticPagesConfig();

  return pageId => aggregatedPages[pageId].data.slug;
};
